import styled from 'styled-components';
// Reusing styles for consistency
import {
    ModalOverlay as BaseModalOverlay,
    ModalContent as BaseModalContent,
    ModalHeader as BaseModalHeader,
    ModalActions as BaseModalActions,
    CancelButton as BaseCancelButton,
} from './AddSubtaskModal.styles';

import {
    StyledInput as BaseSearchInput,
    ParentDropdownList as BaseListContainer,
    ParentDropdownItem as BaseListItem,
    NoResultsMessage as BaseNoResultsMessage,
} from './CardModal.styles';


export const ModalOverlay = styled(BaseModalOverlay)``;
export const ModalContent = styled(BaseModalContent)`
    width: 520px;
`;
export const ModalHeader = styled(BaseModalHeader)``;

export const SearchInput = styled(BaseSearchInput)`
    margin-bottom: 12px;
`;

export const CardListContainer = styled.div`
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #3B444C;
    border-radius: 3px;
    background: #22272B;

    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
    }
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.2) rgba(255, 255, 255, 0.05);
`;

export const CardListItem = styled(BaseListItem)``;

export const NoResultsMessage = styled(BaseNoResultsMessage)``;

export const ModalActions = styled(BaseModalActions)``;
export const CancelButton = styled(BaseCancelButton)``;
